import React from "react";
import jack from "../../Assets/jackdaniel.jpg";
import karrike from "../../Assets/second.jpg";
import fotoja from "../../Assets/third.jpg";
import "./SectionTwoHome.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

const SectionTwoHome = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  //deklarojm slides
  const slides = [
    {
      imageUrl: jack,
      alt: "dogimage",
    },
    {
      imageUrl: karrike,
      alt: "dogimage",
    },
    {
      imageUrl: fotoja,
      alt: "dogimage",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextImage = () => {
    setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
  };
  const prevImage = () => {
    setCurrentSlide(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div>
      <div className="container">
        <div className="image">
          <img
            src={slides[currentSlide].imageUrl}
            alt={slides[currentSlide].alt}
          />

          <div className="indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${currentSlide === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          ></button>
        ))}
        
      </div>
      
        </div>
        <div className="content-right">
          <h3 id="welcome">Welcome to The men's Lounge</h3>
          <p>
            The Gentlemens Lounge offers traditional and modern haircuts and
            beard trims. Everyone is welcome in to the Gentlemens Lounge, we
            have all ages and walks of life come in and out of the shop.
          </p>
          <span></span>
          <p>
            The shop opened on November 14th 2015 when ike Walmsley was 20 years
            old. We have 4 Gents cutting and trimming all day Tuesday 
            Saturday. Walk ins and appointments are available at the Gentlemens
            Lounge so we can cater for as many people as possible.
          </p>
          <Link to="/about">
            <button id="readmorebtn">Read More</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SectionTwoHome;
